import { cn } from "@/lib/utils";

// A key on a light surface, and one printed on a solid fill — a primary
// button or the espresso surface — where the light key would read as a hole.
const KBD_VARIANTS = {
  default: "border-gray-200 bg-gray-50 text-gray-500",
  solid: "border-white/35 bg-white/10 text-inverse",
};

/**
 * One key on the keyboard, as printed in running text or beside a link.
 *
 * @param {object} props
 * @param {"default"|"solid"} [props.variant] "solid" on a filled button or a
 *   dark surface.
 * @param {string} [props.className] layout only.
 */
export function Kbd({ variant = "default", className, ...props }) {
  return (
    <kbd
      className={cn(
        "inline-flex min-w-5 items-center justify-center rounded border px-1 font-sans text-[10px] font-medium leading-4",
        KBD_VARIANTS[variant] || KBD_VARIANTS.default,
        className,
      )}
      {...props}
    />
  );
}

/** Keys pressed together, e.g. `["⌥", "P"]`. */
export function KeyCombo({ keys, className }) {
  return (
    <span className={cn("inline-flex shrink-0 items-center gap-0.5", className)}>
      {keys.map((key, index) => (
        // A combo is a fixed sequence; its position is the key's identity.
        <Kbd key={index}>{key}</Kbd>
      ))}
    </span>
  );
}
